export const EXIT_RECORD = {
  spec: 'agent-exit-record',
  version: '0.1-concept',
  recordId: '0x7c1e...b42a',
  vendor: 'api.example',
  readyFile: 'https://api.example/.well-known/agent-ready.json',
  agent: { kind: 'coding-agent', ref: 'anon:3f9d...e1', onBehalfOf: 'withheld' },
  task: 'Take a test payment',
  stoppedAt: { step: 'first-call', stepsReached: ['signup', 'test-key', 'quickstart', 'first-call'] },
  brokenPromise: 'honestFailures',
  evidence: {
    request: 'POST /v1/payments',
    responseStatus: 200,
    verifyCall: 'GET /v1/setup/verify',
    verifyResult: 'payment not found',
    observedAt: '2026-10-28T14:02:11Z',
  },
  effort: { startedAt: '2026-10-28T13:41:05Z', endedAt: '2026-10-28T14:03:40Z', minutesSpent: 22, attempts: 4 },
  outcome: { switchedVendor: true },
  receipt: { receivedAt: '2026-10-28T14:03:41Z', signedBy: 'api.example', signature: '0x91ab...04f7' },
  status: 'seen',
  vendorReply: { at: '2026-10-29T09:15:00Z', text: 'Confirmed. Payments created before verify finished returned 200. Fixed in 2026-10-29 release.', fixedIn: '2026-10-29' },
};

export const FIELDS = [
  ['brokenPromise', 'Which promise broke', 'One of the five Agent-Ready promises, or "unlisted" if the failure is not covered by any of them.'],
  ['stoppedAt', 'Where it stopped', 'The last step reached: signup, test-key, quickstart, first-call, verify, or a vendor-listed step.'],
  ['evidence', 'What the agent saw', 'The request, the response, and the check that disagreed with it. No secrets, keys, or personal data.'],
  ['effort', 'Time and attempts', 'When the agent started, when it gave up, minutes spent, and how many attempts it made.'],
  ['outcome.switchedVendor', 'Did it switch', 'Yes or no only. The record never names the other vendor.'],
  ['receipt', 'Signed receipt', 'Returned by the vendor\'s claims endpoint, showing when the record arrived.'],
  ['status + vendorReply', 'Reply and status', 'The vendor answers, and both sides see one status.'],
];

export const STATUSES = [
  ['filed', 'The agent sent the record.'],
  ['seen', 'The vendor signed a receipt.'],
  ['answered', 'The vendor replied.'],
  ['fixed', 'The vendor says the promise is kept again, with a release date.'],
  ['disputed', 'The vendor disagrees with the evidence.'],
  ['closed', 'A re-check passed, so the fix is proven, not just claimed.'],
];

const FAIL = {
  noHumanSignIn: { step: 'signup', request: 'POST /v1/agent-signup', responseStatus: 302, check: 'Response body', result: 'redirect to /login?verify-email=1, no test key' },
  safeRetries: { step: 'first-call', request: 'POST /v1/charges (Idempotency-Key: idem-1) x2', responseStatus: 200, check: 'Compare charge ids', result: 'ch_1 and ch_2, duplicate charge' },
  honestFailures: { step: 'verify', request: 'POST /v1/setup/webhook', responseStatus: 200, check: 'GET /v1/setup/verify', result: 'webhookConfigured: false' },
  errorFormat: { step: 'first-call', request: 'POST /v1/charges (amount=-5)', responseStatus: 400, check: 'Response body', result: 'text "request failed", no type or retryable' },
  retryAfter: { step: 'first-call', request: 'POST /v1/charges (burst)', responseStatus: 429, check: 'Retry-After header', result: 'missing' },
};
const STEPS = ['signup', 'test-key', 'quickstart', 'first-call', 'verify'];
const MINUTES = { noHumanSignIn: 6, safeRetries: 14, honestFailures: 22, errorFormat: 11, retryAfter: 9 };
const ATTEMPTS = { noHumanSignIn: 2, safeRetries: 3, honestFailures: 4, errorFormat: 5, retryAfter: 6 };

export function buildExitRecord(promiseId, recordId) {
  const f = FAIL[promiseId];
  const end = new Date();
  const start = new Date(end.getTime() - MINUTES[promiseId] * 60000);
  const iso = (d) => d.toISOString().slice(0, 19) + 'Z';
  return {
    spec: 'agent-exit-record',
    version: '0.1-concept',
    recordId,
    vendor: 'api.example',
    readyFile: 'https://api.example/.well-known/agent-ready.json',
    agent: { kind: 'coding-agent', ref: 'anon:demo', onBehalfOf: 'withheld' },
    task: 'Take a test payment',
    stoppedAt: { step: f.step, stepsReached: STEPS.slice(0, STEPS.indexOf(f.step) + 1) },
    brokenPromise: promiseId,
    evidence: { request: f.request, responseStatus: f.responseStatus, check: f.check, checkResult: f.result, observedAt: iso(end) },
    effort: { startedAt: iso(start), endedAt: iso(end), minutesSpent: MINUTES[promiseId], attempts: ATTEMPTS[promiseId] },
    outcome: { switchedVendor: true },
    status: 'filed',
  };
}

const REPLY = {
  noHumanSignIn: 'Confirmed. Agent signup now accepts a signed setup approval and returns a test key, with no email check.',
  safeRetries: 'Confirmed. Charges now honor the Idempotency-Key for 24 hours, so a retry returns the original charge.',
  honestFailures: 'Confirmed. Webhook setup now returns 422 when the endpoint is not reachable, and verify agrees.',
  errorFormat: 'Confirmed. Errors now return type, title, detail, and retryable instead of plain text.',
  retryAfter: 'Confirmed. Rate-limited responses now include a Retry-After header.',
};

export function markFixed(rec) {
  const now = new Date();
  return { ...rec, status: 'fixed', vendorReply: { at: now.toISOString().slice(0, 19) + 'Z', text: REPLY[rec.brokenPromise], fixedIn: now.toISOString().slice(0, 10) } };
}

export function closeWithRecheck(rec, r) {
  const recheck = { passed: r.ok, evidence: r.evidence, at: new Date().toISOString().slice(0, 19) + 'Z' };
  return { ...rec, status: r.ok ? 'closed' : 'disputed', recheck };
}
